import {useGlobalStore} from "@/stores/useGlobalStore";

export default function useReturnValue() {
    const globalStore = useGlobalStore()

    function setSLAccountDetail(code, key) {
        let selected_account = globalStore.slAccounts.filter(account => account.code === code)
        if(selected_account[0] !== undefined) {
            return selected_account[0][key]
        }
    }

    function setGLAccountDetail(code, key) {
        let selected_account = globalStore.glAccounts.filter(account => account.code === code)
        if(selected_account[0] !== undefined) {
            return selected_account[0][key]
        }
    }

    function setBranchDetail(code, key) {
        let branch = globalStore.branches.filter((obj) => { return obj.code === code })
        if(branch[0]){
            return branch[0][key]
        }
    }

    function setModeOfPaymentDetail(code, key){
        let option = globalStore.modes.filter(opt => opt.code === code)
        if(option[0] !== undefined) {
            return option[0][key]
        }
    }

    function setColumns(columns) {
        let custom_columns = []
        for(const key of Object.keys(columns)){
            let obj = {}
            obj[key] = columns[key].name
            if(columns[key].name) custom_columns.push(obj)
        }

        return custom_columns
    }

    function getSelectedColumns(custom_columns) {
        let selected_columns = []

        for(const key of Object.keys(custom_columns)) {
            selected_columns.push(Object.keys(custom_columns[key]).toString())
        }

        return selected_columns
    }

    function foreignCurrencyConversion(currency, amount) {
        if(currency !== 'PHP') {
            // TODO: Retrieve conversion rate from API and return conversion rate back to object to pass today's conversion rate
            let conversion_rate = 1
            amount = parseFloat(String(amount).replaceAll(',',''))
            return amount * conversion_rate
        }

        return amount
    }

    function returnForeignCurrencyConversionRate(currency, amount) {
        let conversion_rate = 1
        if(currency !== 'PHP') {
            conversion_rate = 1
            // TODO: Retrieve conversion rate from API and return conversion rate back to object
            amount = parseFloat(String(amount).replaceAll(',',''))
            amount = amount * conversion_rate
        }

        return {
            amount: parseFloat(String(amount).replaceAll(',','')),
            conversion_rate: conversion_rate
        }
    }

    function returnUserDetails(key) {
        let user_details = JSON.parse(localStorage.getItem('authUser'))

        return user_details[key]
    }

    function returnSplitValue(data, separator, array_key) {
        let initial_data = data.split(separator)

        return initial_data[array_key]
    }

    return {
        setSLAccountDetail,
        setGLAccountDetail,
        setBranchDetail,
        setModeOfPaymentDetail,
        setColumns,
        getSelectedColumns,
        foreignCurrencyConversion,
        returnForeignCurrencyConversionRate,
        returnUserDetails,
        returnSplitValue
    }
}
